import { render, staticRenderFns } from "./SupplierOrdersButtons.vue?vue&type=template&id=57643f2f&"
import script from "./SupplierOrdersButtons.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports